"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacebookFollow1Schema = void 0;
exports.FacebookFollow1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/facebook-sociallink/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "FacebookFollow1",
    "description": "Add a facebook profile, event or page to follow",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:facebook-sociallink:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "facebookEntityType": {
                    "type": "string",
                    "description": "What is the facebook enitity type behind the follow URL",
                    "enum": [
                        "event",
                        "page",
                        "user"
                    ]
                },
                "href": {
                    "type": "string",
                    "description": "e.g. https://www.facebook.com/redbull/"
                }
            },
            "required": [
                "facebookEntityType",
                "href"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9mYWNlYm9vay1zb2NpYWxsaW5rLzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEscUJBQXFCLEdBQUc7SUFDbkMsS0FBSyxFQUFFLHdGQUF3RjtJQUMvRixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxpQkFBaUI7SUFDMUIsYUFBYSxFQUFFLGlEQUFpRDtJQUNoRSxNQUFNLEVBQUUsUUFBUTtJQUNoQixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sZ0RBQWdEO2FBQ2pEO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixZQUFZLEVBQUU7Z0JBQ1osb0JBQW9CLEVBQUU7b0JBQ3BCLE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUseURBQXlEO29CQUN4RSxNQUFNLEVBQUU7d0JBQ04sT0FBTzt3QkFDUCxNQUFNO3dCQUNOLE1BQU07cUJBQ1A7aUJBQ0Y7Z0JBQ0QsTUFBTSxFQUFFO29CQUNOLE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsd0NBQXdDO2lCQUN4RDthQUNGO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLG9CQUFvQjtnQkFDcEIsTUFBTTthQUNQO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=